import { Container, Eyebrow, Heading, Reveal, Section, Text } from '@nexa/ui';
import { useCopy } from '@/core/i18n';
import { SecurityCard } from './SecurityCard.tsx';

/**
 * `#security` — `template.html:994`.
 *
 * `tone="black"` chứ KHÔNG phải `navy`: thiết kế dùng `surface-black` ở đúng section này và đó là
 * một tone RIÊNG, không phải một bậc tối hơn của navy (`reference.md` §2 hàng 10). Mã màu cố tình
 * không viết ra đây — `check-classes` quét comment theo DÒNG và bắt mọi hex, kể cả trong chú thích.
 *
 * KHÔNG dùng `SectionHead`: nó xếp eyebrow → h2 → lead thành MỘT khối dọc, còn thiết kế ở đây đặt
 * eyebrow+h2 ở cột TRÁI và lead ở cột PHẢI của một grid `1fr 1fr` (`:996`). Ráp bằng `SectionHead`
 * rồi kéo lead sang cột kia là chống lại chính component đó — và `max-w-[60ch]` mặc định của nó sẽ
 * đấu với bề rộng cột, mà `cn()` chỉ nối chuỗi nên thắng thua do thứ tự Tailwind.
 *
 * `align-items:end` của thiết kế chỉ có nghĩa khi hai cột đứng cạnh nhau; ở 1 cột (< `md`) nó
 * thành `align-start` tự nhiên nên không cần khai gì thêm.
 */
export function SecuritySection() {
  const copy = useCopy();

  return (
    <Section id="security" tone="black" labelledBy="security-head" cv className="nx-cv-security">
      <Container>
        <Reveal className="grid gap-16 md:grid-cols-2 md:items-end">
          <div>
            <Eyebrow tone="accent">{copy.security.eyebrow}</Eyebrow>
            <Heading level={2} id="security-head" tone="on-dark" className="mt-[14px]">
              {copy.security.heading}
            </Heading>
          </div>
          <Text size="lead-compact" tone="on-dark-66">
            {copy.security.lead}
          </Text>
        </Reveal>

        <div className="mt-11 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
          {copy.security.cards.map((card) => (
            <Reveal key={card.title} className="h-full">
              <SecurityCard {...card} />
            </Reveal>
          ))}
        </div>
      </Container>
    </Section>
  );
}
